import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.blacklistLearnersFilter;

export const personalisedMenteeEmailersFilterSelector = baseSelector;

export const isBlacklistedMenteeModalOpenSelector = createSelector(
  (state) => baseSelector(state).isModalOpen,
  (isModalOpen) => isModalOpen
);

export const appliedFiltersSelector = createSelector(
  (state) => baseSelector(state).learnerEmail.applied,
  (state) => baseSelector(state).superBatch.applied,
  (learnerEmail, superBatch) => ({
    learnerEmail,
    superBatch,
  })
);

export const currentFiltersSelector = createSelector(
  (state) => baseSelector(state).learnerEmail.current,
  (state) => baseSelector(state).superBatch.current,
  (learnerEmail, superBatch) => ({
    learnerEmail,
    superBatch,
  })
);
